import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { LibrariesPageComponent } from '@pages/packages/libraries.page';
import { NugetChangelogComponent } from '@pages/packages/shared/nuget-changelog';
import { NugetChangelogListComponent } from '@pages/packages/shared/nuget-changelog-list';
import { ProcessIOParametersModule } from '@pages/process/shared';
import {
    CommonNugetService,
    NugetViewerService,
    PackageService,
} from '@services';
import { NugetViewerTranslationService } from '@services/nuget.viewer.translation.service';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiProgressButtonModule } from '@uipath/angular/directives/ui-progress-button';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';
import {
    IPACKAGE_DATA_SOURCE,
    LiteralsTranslationService,
    UiWorkflowWebViewerModule,
} from '@uipath/workflow-web-viewer';

import { NugetVersionsGridComponent } from './grids';
import {
    NugetUpgradeModalComponent,
    NugetUploadModalComponent,
    NugetVersionsModalComponent,
    NugetViewerModalComponent,
} from './modals';
import { PackagesPageComponent } from './packages.page';

const MODALS = [
    NugetVersionsModalComponent,
    NugetUpgradeModalComponent,
    NugetUploadModalComponent,
    NugetViewerModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        ProcessIOParametersModule,
        UiDragAndDropModule,
        UiDateFormatModule,
        UiNgLetModule,
        UiProgressButtonModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
        UiWorkflowWebViewerModule,
    ],
    declarations: [
        NugetVersionsGridComponent,
        NugetChangelogComponent,
        NugetChangelogListComponent,
        PackagesPageComponent,
        LibrariesPageComponent,
        ...MODALS,
    ],
    entryComponents: [
        ...MODALS,
    ],
    providers: [
        CommonNugetService,
        PackageService,
        {
            provide: IPACKAGE_DATA_SOURCE,
            useClass: NugetViewerService,
        },
        {
            provide: LiteralsTranslationService,
            useClass: NugetViewerTranslationService,
        },
    ],
})
export class NugetModule { }
